import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <div className={styles.footer}>
      <div>
        <div>
          <p className={styles.p}>AXELSSONS ELEKTRISKA &#169; 2021-2022</p>
        </div>
      </div>
      <div className={styles.author}>
        <p>Author: Kent Jakobsson @ www.Imonit.nu</p>
        <p>
          <a
            style={{ textDecoration: 'none', color: 'white' }}
            href="mailto:kent@imonit.nu"
          >
            kent@imonit.nu
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
